import React, { useState, useEffect, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AdminBuilderService from "../../../API/Services/AdminService/AdminBuilderService";
import MainPagetitle from "../../layouts/MainPagetitle";
import "./Report.css";
import AdminReportService from "../../../API/Services/AdminService/AdminReportService";
import moment from "moment";
import axios from "axios";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ClipLoader from "react-spinners/ClipLoader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";
import { getStoredSubscriptionDataTypes, safeJsonParse } from "../../../utils/subscriptionAccess";

const BuilderTable = () => {
  const navigate = useNavigate();

  const [Error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [reportList, setReportList] = useState([]);
  const [reportListCount, setReportListCount] = useState(0);
  const [weekEndingDateList, setWeekEndingDateList] = useState([]);
  const recordsPage = 10;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = reportListCount === 0 ? 0 : lastIndex - recordsPage + 1;
  const records = reportList;
  const npage = Math.ceil(reportListCount / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [isLoading, setIsLoading] = useState(false);
  const [BuilderList, setBuilderList] = useState([]);
  const [BuilderCode, setBuilderCode] = useState("");
  const [SubdivisionCode, setSubdivisionCode] = useState("");
  const [SelectedSubdivision, setSelectedSubdivision] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [weekEndingDate, setWeekEndingDate] = useState("");
  const [reportType, setReportType] = useState("List of Active New Home Builders");
  const [message, setMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [selectYear, setSelectYear] = useState("");
  const [selectQuarter, setSelectQuarter] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [value, setValue] = useState("1");
  const [reportOption, setReportOption] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isSavingReport, setIsSavingReport] = useState(false);

  useEffect(() => {
    if (Error) {
      setTimeout(() => {
        setError("");
      }, 3000);
    }
  }, [Error]);

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1);

    const formatDate = (date) => {
      const padToTwoDigits = (num) => num.toString().padStart(2, '0');
      return `${padToTwoDigits(date.getMonth() + 1)}/${padToTwoDigits(date.getDate())}/${date.getFullYear()}`;
    };

    setStartDate(formatDate(firstDayOfYear));
    setEndDate(formatDate(currentDate));
  }, [reportType]);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      GetWeekEndingDateList();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      getreportlist();
    }
  }, [currentPage]);

  useEffect(() => {
    if (reportType == "Subdivision Analysis Report") {
      GetBuilderlist();
    }
  }, [reportType]);

  useEffect(() => {
    const desiredOrder = [
      'List of Active New Home Builders',
      'Active Adult Activity Report',
      'Annual Report',
      'Area Summaries Report',
      'Closing Report(PDF)',
      'Closing Report(XLS)',
      'LV Quartley Traffic and Sales Summary',
      'Market Share Analysis Report',
      'Permits Rankings Report',
      'Subdivision Analysis Report',
      'The Las vegas land Report',
      'Weekly Traffic and Sales Watch(PDF)',
      'Weekly Traffic and Sales Watch(XLS)'
    ];

    const defaultReports = desiredOrder.map((title) => ({
      value: title,
      label: title,
    }));

    const isNewUser = Number(safeJsonParse(localStorage.getItem("new_user"))) === 1;
    const userRole = safeJsonParse(localStorage.getItem("user"))?.role;
    const subscriptionDataTypes = getStoredSubscriptionDataTypes();

    if (subscriptionDataTypes.length > 0 && isNewUser && userRole !== "Admin") {
      const rawSubscriptionData = safeJsonParse(localStorage.getItem("subscription_data_types"));
      const legacyReports = Array.isArray(rawSubscriptionData?.reports)
        ? rawSubscriptionData.reports
        : [];

      const reportsFromLegacyShape = legacyReports.flatMap((reportObject) =>
        Object.values(reportObject).map((report) => ({
          value: report.title,
          label: report.title,
        })),
      );

      const reportsFromModules = subscriptionDataTypes.flatMap((dataType) =>
        (dataType.data_type_modules || [])
          .filter((module) => module.type === "report")
          .map((module) => ({
            value: module.title,
            label: module.title,
          })),
      );

      const subscriptionPlan = safeJsonParse(localStorage.getItem("subscription_plan"));
      const subscriptionPlanTitle = typeof subscriptionPlan === "string"
        ? subscriptionPlan
        : subscriptionPlan?.title;

      const formattedReports = [...reportsFromLegacyShape, ...reportsFromModules];

      if (subscriptionPlanTitle === "Enterprise") {
        formattedReports.push({
          value: "Subdivision Analysis Report",
          label: "Subdivision Analysis Report"
        });
      }

      const uniqueReports = Array.from(
        new Map(formattedReports.map((report) => [report.value, report])).values(),
      );

      const filteredReports = desiredOrder.map(title =>
        uniqueReports.find(report => report.value === title)
      ).filter(report => report !== undefined);

      setReportOption(filteredReports.length > 0 ? filteredReports : defaultReports);
    } else {
      setReportOption(defaultReports);
    }
  }, []);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const changeCPage = (id) => {
    setCurrentPage(id);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleFilterDateFrom = (date) => {
    if (date) {
      const formattedDate = date.toLocaleDateString('en-US');
      setStartDate(formattedDate);
    } else {
      setStartDate('');
    }
  };

  const handleFilterDateTo = (date) => {
    if (date) {
      const formattedDate = date.toLocaleDateString('en-US');
      setEndDate(formattedDate);
    } else {
      setEndDate('');
    }
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;

    const [month, day, year] = dateString.split('/');
    const parsedDate = new Date(year, month - 1, day);

    if (isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate;
  };

  const handleChange = (e, newValue) => {
    e.preventDefault();
    setValue(newValue);
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000;

    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
    }

    return btoa(binary);
  };

  const saveGeneratedPdfReport = (reportdata, response) => {
    const content = arrayBufferToBase64(response.data);

    return AdminReportService.pdfSave({
      ...reportdata,
      content,
      pdf_content: content,
      file: content,
    }).json();
  };

  const getreportlist = async () => {
    try {
      const response = await AdminReportService.reportList(currentPage, recordsPage);
      const responseData = await response.json();
      const data = Array.isArray(responseData?.data)
        ? responseData.data
        : Array.isArray(responseData)
          ? responseData
          : [];
      const total = responseData?.meta?.total ?? responseData?.total ?? data.length;

      setReportList(data);
      setReportListCount(total);
    } catch (error) {
      if (error.name == "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      } else {
        setError("Something went wrong");
      }
    }
  };

  const GetWeekEndingDateList = async () => {
    try {
      const response = await AdminReportService.weekending_date_list();
      const responseData = await response.json();
      setWeekEndingDateList(responseData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      } else {
        setError("Something went wrong");
      }
    }
  };

  const handlePreview = async (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);
    if (reportType == "Closing Report(PDF)" || reportType == "Market Share Analysis Report") {
      let start_Date = moment(startDate);
      let end_Date = moment(endDate);
      let days = end_Date.diff(start_Date, 'days', true);
      let totaldays = Math.ceil(days) + 1;
      if (totaldays < 367) {
        setAlert(false);
        setIsLoading(true);
        localStorage.setItem("start_date", startDate);
        localStorage.setItem("end_date", endDate);
        localStorage.setItem("report_type", reportType);


        const reportdata = {
          type: reportType,
          start_date: startDate,
          end_date: endDate,
        };
        const bearerToken = JSON.parse(localStorage.getItem("usertoken"));
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,

            reportdata,
            {
              responseType: "arraybuffer",
              headers: {
                Accept: "application/pdf",
                Authorization: `Bearer ${bearerToken}`,
              },
            }
          );
          setIsLoading(false);
          handlePdfResponse(response);
          let responseData = await saveGeneratedPdfReport(reportdata, response);
          if (responseData.status) {
            swal("Report Saved Succesfully").then((willDelete) => {
              if (willDelete) {
                setIsSavingReport(false);
                getreportlist();
                navigate("/report");
              }
            });
          }
        } catch (error) {
          setIsLoading(false);
          if (error.name === "HTTPError") {
            const errorJson = await error.response.json();
            setError(errorJson.message);
          }
          setError("Something went wrong");
          setIsButtonDisabled(false);
          setIsSavingReport(false);
        }
      } else {
        setAlert(true);
        setIsButtonDisabled(false);
        setIsSavingReport(false);
        setAlertMessage("Please select 12 month Period for your report.");
        return;
      }
    } else if (reportType == "Closing Report(XLS)") {
      let start_Date = moment(startDate);
      let end_Date = moment(endDate);
      let days = end_Date.diff(start_Date, 'days', true);
      let totaldays = Math.ceil(days) + 1;

      if (totaldays < 367) {
        setAlert(false);
        setIsLoading(true);
        localStorage.setItem("start_date", startDate);
        localStorage.setItem("end_date", endDate);
        localStorage.setItem("report_type", reportType);

        const reportdata = {
          type: reportType,
          start_date: startDate,
          end_date: endDate,
        };

        const bearerToken = JSON.parse(localStorage.getItem("usertoken"));

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,
            reportdata,
            {
              responseType: "arraybuffer",
              headers: {
                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                Authorization: `Bearer ${bearerToken}`,
              },
            }
          );

          setIsLoading(false);
          setIsButtonDisabled(false);
          const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Closing ${startDate} to ${endDate}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          setIsLoading(false);
          if (error.name === "HTTPError") {
            const errorJson = await error.response.json();
            setError(errorJson.message);
          }
          setError("Something went wrong");
          setIsButtonDisabled(false);
          setIsSavingReport(false);
        }
      } else {
        setAlert(true);
        setIsButtonDisabled(false);
        setIsSavingReport(false);
        setAlertMessage("Please select 12 month Period for your report.");
        return;
      }
    } else if (reportType == "Weekly Traffic and Sales Watch(PDF)") {
      if (weekEndingDate == "") {
        setAlert(true);
        setIsButtonDisabled(false);
        setIsSavingReport(false);
        setAlertMessage("Please select week ending date");
        return;
      }
      setAlert(false);
      setIsLoading(true);
      localStorage.setItem("start_date", startDate);
      localStorage.setItem("end_date", endDate);
      localStorage.setItem("report_type", reportType);

      const date = new Date(weekEndingDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}${month}${day}`;

      const reportdata = {
        type: reportType,
        end_date: weekEndingDate,
      };
      const bearerToken = JSON.parse(localStorage.getItem("usertoken"));
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,

          reportdata,
          {
            responseType: "arraybuffer",
            headers: {
              Accept: "application/pdf",
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );
        setIsLoading(false);
        handlePdfResponse(response);
        let responseData = await saveGeneratedPdfReport(reportdata, response);
        if (responseData.status) {
          swal("Report Saved Succesfully").then((willDelete) => {
            if (willDelete) {
              setIsSavingReport(false);
              getreportlist();
              navigate("/report");
            }
          });
        }
      } catch (error) {
        setIsLoading(false);
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
        setError("Something went wrong");
        setIsButtonDisabled(false);
        setIsSavingReport(false);
      }
    } else if (reportType == "Weekly Traffic and Sales Watch(XLS)") {
      if (weekEndingDate == "") {
        setAlert(true);
        setIsButtonDisabled(false);
        setIsSavingReport(false);
        setAlertMessage("Please select week ending date");
        return;
      }
      setAlert(false);
      setIsLoading(true);
      localStorage.setItem("start_date", startDate);
      localStorage.setItem("end_date", endDate);
      localStorage.setItem("report_type", reportType);

      const date = new Date(weekEndingDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}${month}${day}`;

      const reportdata = {
        type: reportType,
        end_date: weekEndingDate,
      };
      const bearerToken = JSON.parse(localStorage.getItem("usertoken"));
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,
          reportdata,
          {
            responseType: "arraybuffer",
            headers: {
              Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );

        setIsLoading(false);
        setIsButtonDisabled(false);
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `WTSW ${formattedDate}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        setIsLoading(false);
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
        setError("Something went wrong");
        setIsButtonDisabled(false);
        setIsSavingReport(false);
      }
    } else if (reportType == "LV Quartley Traffic and Sales Summary") {
      if (selectYear == "" || selectQuarter == "") {
        setAlert(true);
        setIsButtonDisabled(false);
        setIsSavingReport(false);
        setAlertMessage("Please select year and quarter");
        return;
      }
      setAlert(false);
      setIsLoading(true);
      localStorage.setItem("start_date", startDate);
      localStorage.setItem("end_date", endDate);
      localStorage.setItem("report_type", reportType);

      const reportdata = {
        type: reportType,
        year: selectYear,
        quarter: selectQuarter,
      };
      const bearerToken = JSON.parse(localStorage.getItem("usertoken"));
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,

          reportdata,
          {
            responseType: "arraybuffer",
            headers: {
              Accept: "application/pdf",
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );
        setIsLoading(false);
        handlePdfResponse(response);
        let responseData = await saveGeneratedPdfReport(reportdata, response);
        if (responseData.status) {
          swal("Report Saved Succesfully").then((willDelete) => {
            if (willDelete) {
              setIsSavingReport(false);
              getreportlist();
              navigate("/report");
            }
          });
        }
      } catch (error) {
        setIsLoading(false);
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
        setError("Something went wrong");
        setIsButtonDisabled(false);
        setIsSavingReport(false);
      }
    } else if (reportType == "Subdivision Analysis Report") {
      if (BuilderCode == "" || SubdivisionCode == "") {
        setAlert(true);
        setIsButtonDisabled(false);
        setIsSavingReport(false);
        setAlertMessage("Please select builder and subdivision both.");
        return;
      }
      setIsLoading(true);
      const today = new Date();
      const formattedToday = today.toISOString().split('T')[0];
      localStorage.setItem("start_date", startDate);
      localStorage.setItem("end_date", endDate);
      localStorage.setItem("report_type", reportType);

      const reportdata = {
        type: reportType,
        start_date: formattedToday,
        end_date: formattedToday,
        id: SubdivisionCode
      };

      const bearerToken = JSON.parse(localStorage.getItem("usertoken"));

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,
          reportdata,
          {
            responseType: "arraybuffer",
            headers: {
              Accept: "application/pdf",
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );
        setIsLoading(false);
        handlePdfResponse(response);
        let responseData = await saveGeneratedPdfReport(reportdata, response);
        if (responseData.status) {
          swal("Report Saved Succesfully").then((willDelete) => {
            if (willDelete) {
              setIsSavingReport(false);
              getreportlist();
              navigate("/report");
            }
          });
        }
      } catch (error) {
        setIsLoading(false);
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
        setError("Something went wrong");
        setIsButtonDisabled(false);
        setIsSavingReport(false);
      }
    } else {
      setIsLoading(true);
      localStorage.setItem("start_date", startDate);
      localStorage.setItem("end_date", endDate);
      localStorage.setItem("report_type", reportType);

      const reportdata = {
        type: reportType,
        start_date: startDate,
        end_date: endDate,
      };

      const bearerToken = JSON.parse(localStorage.getItem("usertoken"));

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,
          reportdata,
          {
            responseType: "arraybuffer",
            headers: {
              Accept: "application/pdf",
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );
        setIsLoading(false);
        handlePdfResponse(response);
        let responseData = await saveGeneratedPdfReport(reportdata, response);
        if (responseData.status) {
          swal("Report Saved Succesfully").then((willDelete) => {
            if (willDelete) {
              setIsSavingReport(false);
              getreportlist();
              navigate("/report");
            }
          });
        }
      } catch (error) {
        setIsLoading(false);
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
        setError("Something went wrong");
        setIsButtonDisabled(false);
        setIsSavingReport(false);
      }
    }
  };

  const handlePdfResponse = (response, isSaveFlow = true) => {
    setIsButtonDisabled(false);
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setPdfUrl(url);
    setIsSavingReport(isSaveFlow);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleString();
    return formattedDate;
  };

  const handleDelete = async (e) => {
    try {
      let responseData = await AdminReportService.destroyReport(e).json();
      if (responseData.status === true) {
        if (records.length === 1 && currentPage > 1) {
          setCurrentPage(currentPage - 1);
        } else {
          getreportlist();
        }
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      } else {
        setError("Something went wrong");
      }
    }
  };

  const handleReportPreview = async (e, report) => {
    e.preventDefault();

    if (report?.report_type === "List of Active New Home Builders") {
      setIsLoading(true);

      const reportdata = {
        type: report.report_type,
        start_date: report.start_date || report.from_date || startDate,
        end_date: report.end_date || report.to_date || endDate,
      };
      const bearerToken = JSON.parse(localStorage.getItem("usertoken"));

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,
          reportdata,
          {
            responseType: "arraybuffer",
            headers: {
              Accept: "application/pdf",
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );

        handlePdfResponse(response, false);
      } catch (error) {
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        } else {
          setError("Something went wrong");
        }
      } finally {
        setIsLoading(false);
      }

      return;
    }

    const blob = base64toBlob(report.content);
    const url = URL.createObjectURL(blob);
    setPdfUrl(url);
    setIsSavingReport(false);
  };

  const base64toBlob = (base64Data) => {
    const normalizedBase64 = base64Data.includes(",")
      ? base64Data.split(",").pop()
      : base64Data;
    const byteCharacters = atob(normalizedBase64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: "application/pdf" });
    return blob;
  };

  const handleReportType = (e) => {
    setReportType(e.target.value);
    setAlert(false);
    if (e.target.value == "Closing Report(PDF)" || e.target.value == "Closing Report(XLS)" || e.target.value == "Market Share Analysis Report") {
      setMessage("Choose a 12 Month Period for Your Report and Click Save");
    }
  };

  const options = weekEndingDateList.map((date) => ({
    label: date,
    value: date
  }));

  const handleWeekEndingDate = (date) => {
    setWeekEndingDate(date.value);
  };

  const GetBuilderlist = async () => {
    setIsLoading(true);
    try {
      const response = await AdminBuilderService.all_builder_list();
      const responseData = await response.json();
      setIsLoading(false);
      setBuilderList(responseData);

    } catch (error) {
      setIsLoading(false);
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      } else {
        setError("Something went wrong");
      }
    }
    setIsLoading(false);
  };

  const BuilderOptions = BuilderList
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(element => ({
      value: element.id,
      label: element.name
    }));

  const handleBuilderCode = (code) => {
    setBuilderCode(code.value);
    setSubdivisionCode("");
    setSelectedSubdivision([]);
  };

  const handleSubdivisionCode = (code) => {
    setSelectedSubdivision(code);
    setSubdivisionCode(code?.value || "");
  };

  return (
    <Fragment>
      <MainPagetitle mainTitle="Report" pageTitle="Report" parentTitle="Home" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-6">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <Box>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Generate Report" value="1" />
                    <Tab label="Report List" value="2" />
                  </TabList>
                </Box>
                {/* Generate Report Tab */}
                <TabPanel value="1" className="p-0">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="active-projects style-1 ItemsCheckboxSec shorting">
                        <div className="tbl-caption d-flex text-wrap">
                          <h3 className="mb-0">Generate New Report</h3>
                          <p className="text-danger">{Error}</p>
                        </div>
                        <div className="dataTables_wrapper no-footer">
                          <div className="row">
                            <div className="mb-2 col-md-7 d-flex align-items-center flex-column-mobile">
                              <span className="col-md-6">
                                <div className="ms-4">Select Report</div>
                              </span>
                              <select
                                onChange={(e) => handleReportType(e)}
                                value={reportType}
                                className="form-control-select"
                              >
                                {reportOption?.map((data) => (
                                  <option>{data.label}</option>
                                ))}
                              </select>
                            </div>

                            <div className="col-md-12" style={{ marginTop: "10px" }}>
                              <div className="d-flex">
                                <p className="text-center ms-4">
                                  {(reportType == "Closing Report(PDF)" || reportType == "Closing Report(XLS)" || reportType == "Market Share Analysis Report") ? message : reportType == "LV Quartley Traffic and Sales Summary" ? "Select Year and Quarter" : reportType == "Subdivision Analysis Report" ? "Select builder and subdivision" : reportType == "Weekly Traffic and Sales Watch(PDF)" ? "Select Week Ending Date and Click Save" : reportType == "List of Active New Home Builders" ? "" : "Select Your Date Range and Click Save"}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-7 d-flex align-items-center flex-column-mobile">
                              <div className="col-md-5">
                                {reportType == "Subdivision Analysis Report" ?
                                  <div className="ms-4 sm-m-0">Select Builder & Subdivision</div>
                                  :
                                  (reportType == "List of Active New Home Builders" ?
                                    <div className="ms-4 sm-m-0"></div>
                                    :
                                    <div className="ms-4 sm-m-0">Select Period</div>)
                                }
                              </div>
                              {(reportType != "Weekly Traffic and Sales Watch(PDF)" && reportType != "Weekly Traffic and Sales Watch(XLS)" && reportType != "LV Quartley Traffic and Sales Summary" && reportType != "Subdivision Analysis Report" && reportType != "List of Active New Home Builders") && <div className="me-2 mb-2">
                                <DatePicker
                                  name="from"
                                  className="form-control"
                                  selected={parseDate(startDate)}
                                  onChange={handleFilterDateFrom}
                                  dateFormat="MM/dd/yyyy"
                                  placeholderText="mm/dd/yyyy"
                                />

                              </div>}

                              {(reportType != "Weekly Traffic and Sales Watch(PDF)" && reportType != "Weekly Traffic and Sales Watch(XLS)" && reportType != "LV Quartley Traffic and Sales Summary" && reportType != "Subdivision Analysis Report" && reportType != "List of Active New Home Builders") && <div className="mb-2">
                                <DatePicker
                                  name="to"
                                  className="form-control"
                                  selected={parseDate(endDate)}
                                  onChange={handleFilterDateTo}
                                  dateFormat="MM/dd/yyyy"
                                  placeholderText="mm/dd/yyyy"
                                />
                              </div>}

                              {(reportType == "Weekly Traffic and Sales Watch(PDF)" || reportType == "Weekly Traffic and Sales Watch(XLS)") && <div className="mb-2 col-md-7 d-flex align-items-center flex-column-mobile">
                                <Select
                                  options={options}
                                  onChange={(selectedOption) => handleWeekEndingDate(selectedOption)}
                                  placeholder="Select Date"
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: '100%',
                                      color: 'black'
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      width: '180px',
                                      color: 'black'
                                    }),
                                  }}
                                />
                              </div>}

                              {reportType === "LV Quartley Traffic and Sales Summary" && (
                                <div className="d-flex align-items-center">
                                  <div className="me-2 mb-2" style={{ width: "100px" }}>
                                    <select id="yearSelect" className="form-select" style={{ backgroundColor: "white", height: "35px", color: "black" }} onChange={(e) => setSelectYear(e.target.value)}>
                                      <option value="">Select Year</option>
                                      {Array.from({ length: 15 }, (_, i) => {
                                        const year = new Date().getFullYear() - i;
                                        return (
                                          <option key={year} value={year} style={{ width: "0px", color: "black" }}>
                                            {year}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className="mb-2" style={{ width: "150px", marginLeft: "10px" }}>
                                    <select id="quarterSelect" className="form-select" style={{ backgroundColor: "white", height: "35px", color: "black" }} onChange={(e) => setSelectQuarter(e.target.value)}>
                                      <option value="">Select Quarter</option>
                                      <option value="Q1">Q1 - Jan to Mar</option>
                                      <option value="Q2">Q2 - Apr to Jun</option>
                                      <option value="Q3">Q3 - Jul to Sep</option>
                                      <option value="Q4">Q4 - Oct to Dec</option>
                                    </select>
                                  </div>
                                </div>
                              )}

                              {reportType == "Subdivision Analysis Report" && (
                                <div div className="d-flex justify-content-center">
                                  <div style={{ width: "155px", marginLeft: "20px" }}>
                                    <Select
                                      options={BuilderOptions}
                                      onChange={(selectedOption) => handleBuilderCode(selectedOption)}
                                      placeholder="Select Builder"
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: '100%',
                                          color: 'black'
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          width: '100%',
                                          color: 'black'
                                        }),
                                      }}
                                    />
                                  </div>

                                  {BuilderCode &&
                                    <div style={{ width: "200px", marginLeft: "10px" }}>
                                      <LazySubdivisionMultiSelect
                                        builderIds={[BuilderCode]}
                                        value={SelectedSubdivision}
                                        onChange={(selectedOption) => handleSubdivisionCode(selectedOption)}
                                        placeholder="Select Subdivision"
                                        isMulti={false}
                                      />
                                    </div>
                                  }
                                </div>
                              )}
                            </div>

                            {alert && (reportType == "Closing Report(PDF)" || reportType == "Closing Report(XLS)" || reportType == "Market Share Analysis Report" || reportType == "LV Quartley Traffic and Sales Summary" || reportType == "Weekly Traffic and Sales Watch(PDF)" || reportType == "Weekly Traffic and Sales Watch(XLS)" || reportType == "Subdivision Analysis Report") &&
                              <div className="col-md-12" style={{ marginTop: "10px", color: "red" }}>
                                <div className="d-flex">
                                  <p className="text-center ms-4">
                                    {alertMessage}
                                  </p>
                                </div>
                              </div>
                            }
                          </div>

                          <div className="col-md-7 d-flex justify-content-center" style={{ marginLeft: isButtonDisabled ? "300px" : isSavingReport ? "310px" : "320px", marginTop: "20px" }}>
                            <div className="ms-4 mb-4">
                              <a
                                onClick={handlePreview}
                                className={`btn btn-primary ${isButtonDisabled || isSavingReport ? "disabled" : ""}`}
                                style={{ pointerEvents: isButtonDisabled || isSavingReport ? "none" : "auto", opacity: isButtonDisabled || isSavingReport ? 0.5 : 1 }}
                              >
                                {isButtonDisabled ? "Processing..." : isSavingReport ? "Saving..." : "Save"}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>

                {/* Report List Tab */}
                <TabPanel value="2" className="p-0">
                  <div className="card">
                    <div className="card-body p-0">
                      <div
                        id="employee-tbl_wrapper report-table"
                        className="dataTables_wrapper no-footer table-responsive active-projects style-1 ItemsCheckboxSec shorting"
                      >
                        <table
                          id="empoloyees-tblwrapper"
                          className="table ItemsCheckboxSec dataTable no-footer mb-0 report-table"
                        >
                          <thead>
                            <tr style={{ textAlign: "center" }}>
                              <th>
                                <strong>Name</strong>
                              </th>
                              <th>
                                <strong>Report</strong>
                              </th>
                              <th>
                                <strong>Saved at</strong>
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody style={{ textAlign: "center" }}>
                            {records.map((element, index) => {
                              return (
                                <tr key={index} style={{ textAlign: "center" }}>
                                  <td>
                                    <a
                                      href="#"
                                      onClick={(e) => handleReportPreview(e, element)}
                                      className="text-decoration-none"
                                    >
                                      {element.name}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      onClick={(e) => handleReportPreview(e, element)}
                                      className="text-decoration-none"
                                    >
                                      {element.report_type.length > 20
                                        ? element.report_type.substring(0, 20) +
                                        "...   "
                                        : element.report_type}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      onClick={(e) => handleReportPreview(e, element)}
                                      className="text-decoration-none"
                                    >
                                      {formatDate(element.created_at)}
                                    </a>
                                  </td>
                                  <td>
                                    <div className="d-flex justify-content-center">
                                      <Link
                                        onClick={() =>
                                          swal({
                                            title: "Are you sure?",
                                            icon: "warning",
                                            buttons: true,
                                            dangerMode: true,
                                          }).then((willDelete) => {
                                            if (willDelete) {
                                              handleDelete(element.id);
                                            }
                                          })
                                        }
                                        className="btn btn-danger shadow btn-xs sharp"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        <div className="d-sm-flex text-center justify-content-end align-items-center">
                          <div className="dataTables_info me-auto">
                            Showing {firstIndex} to{" "}
                            {Math.min(lastIndex, reportListCount)} of{" "}
                            {reportListCount} entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers justify-content-center"
                            id="example2_paginate"
                          >
                            <Link
                              className="paginate_button previous disabled"
                              to="#"
                              onClick={prePage}
                            >
                              <i className="fa-solid fa-angle-left" />
                            </Link>
                            <span>
                              {number.map((n, i) => {
                                if (
                                  n === 1 ||
                                  n === npage ||
                                  n === currentPage ||
                                  n === currentPage - 1 ||
                                  n === currentPage + 1
                                ) {
                                  return (
                                    <Link
                                      className={`paginate_button ${currentPage === n ? "current" : ""
                                        } `}
                                      key={i}
                                      onClick={() => changeCPage(n)}
                                    >
                                      {n}
                                    </Link>
                                  );
                                }
                                if (
                                  (n === currentPage - 2 && currentPage > 4) ||
                                  (n === currentPage + 2 && currentPage < npage - 3)
                                ) {
                                  return (
                                    <span key={i} className="paginate_button disabled">
                                      ...
                                    </span>
                                  );
                                }
                                return null;
                              })}
                            </span>
                            <Link
                              className="paginate_button next"
                              to="#"
                              onClick={nextPage}
                            >
                              <i className="fa-solid fa-angle-right" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>

          <div className="col-xl-6 mt-5 report-preview-column">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center mb-5" style={{ marginTop: "35%" }}>
                <ClipLoader color="#4474fc" />
              </div>
            ) : (Error != "" && pdfUrl == "" ? (
              <div style={{ textAlign: "center", marginTop: "30%", fontSize: "60px", color: "black" }}>
                <i className="bi bi-exclamation-octagon" />
              </div>
            ) : pdfUrl != "" && (
              <div className="report-preview-frame">
                <embed
                  src={pdfUrl}
                  type="application/pdf"
                  width="100%"
                  height="100%"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BuilderTable;
